class clearFilter extends HTMLElement {
    constructor() {
        super();

        this.mainBlog = document.querySelector("[js-main-blog]");
        this.sectionId = this.mainBlog.dataset.sectionId;
        this.filterItem = this.mainBlog.querySelector('[data-tag-handle="all"]');
        this.tagUrl = this.filterItem.dataset.tagUrl;

        this.init();
    };

    init() {
        this.addEventListener('click', (e) => {
            e.preventDefault();

            document.dispatchEvent(new CustomEvent("scroll:init"));
            document.dispatchEvent(new CustomEvent("loading:init", {
                detail: {
                    loading: true
                }
            }));
            document.dispatchEvent(new CustomEvent("changeState", {
                detail: {
                    target: this.filterItem
                }
            }));
            document.dispatchEvent(new CustomEvent("updateHistoryState", {
                detail: {
                    url: this.tagUrl
                }
            }));
            this.renderAjaxBlog(this.tagUrl);
        })
    };
   
    renderAjaxBlog(tagUrl) {    
        const url = `${tagUrl}?section_id=${this.sectionId}`;    

        fetch(url).then(function(response) {
            return response.text();
        }).then((html) => {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');

            doc.querySelector(".Blog_alternate_template_2_leftside_filter_new").classList.add("open");
            this.mainBlog.innerHTML = doc.querySelector("[js-main-blog]").innerHTML;
            document.dispatchEvent(new CustomEvent("dropdown:init"));
            document.dispatchEvent(new CustomEvent("filter-drawer:init"));
            document.dispatchEvent(new CustomEvent("loading:init", {
                detail: {
                    loading: false
                }
            }));
        });
    }
}
    
customElements.define('clear-filter', clearFilter);